var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded && !_vm.error)?_c('h1',[_vm._v(" Bewertung "),_c('span',{staticClass:"heading-appendix"},[_vm._v(_vm._s(_vm.challengeTitle))])]):_c('content-loader',{staticClass:"loader-bar",attrs:{"height":15}},[_c('rect',{attrs:{"height":"100%","width":"60%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }